export var RecaptchaAction = /*#__PURE__*/function (RecaptchaAction) {
  RecaptchaAction["payment"] = "payment";
  RecaptchaAction["register"] = "register";
  RecaptchaAction["manageSubscription"] = "manage_subscription";
  RecaptchaAction["managePaymentMethod"] = "manage_payment_method";
  RecaptchaAction["retryCharge"] = "retry_charge";
  return RecaptchaAction;
}(RecaptchaAction || {});
export const VALID_RECAPTCHA_ACTION_REGEX = /^[a-zA-Z0-9/_]+$/;